export default function AchievementSection() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-white via-slate-50 to-white text-slate-900 pt-16 pb-8 md:pt-20 md:pb-10">
      {/* Background blobs */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-br from-indigo-200/40 via-sky-200/30 to-cyan-200/35 blur-3xl" />
        <div className="absolute -bottom-40 left-[-120px] h-[420px] w-[420px] rounded-full bg-gradient-to-br from-emerald-200/35 via-lime-200/20 to-cyan-200/25 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1280px] px-6 md:px-8">
        {/* Header */}
        <div className="mb-10 text-center">
          <h2 className="text-5xl font-extrabold uppercase tracking-wide text-blue-600">
            Achievement
          </h2>
          <p className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Making Quantitative Trading More Accessible
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-500">
            LingCopilot combines dynamic knowledge, collaborative reasoning, and zero‑code strategy building.
          </p>
        </div>

        <p className="mt-8 mb-6 text-center text-xl font-bold tracking-tight text-slate-800">
          Three Ways LingCopilot Simplifies Quant Investing
        </p>

        {/* Three image cards */}
        <div className="mx-auto max-w-5xl mt-8 flex items-stretch justify-center gap-6">
          <div className="flex-1 rounded-2xl border-2 border-blue-200 overflow-hidden bg-white shadow-[0_4px_20px_0_rgba(99,102,241,0.08)]">
            <img
              alt="Dynamic Knowledge"
              src="/assets/home/dynamic_knowledge.webp"
              className="w-full h-auto block"
            />
          </div>
          <div className="flex-1 rounded-2xl border-2 border-blue-200 overflow-hidden bg-white shadow-[0_4px_20px_0_rgba(99,102,241,0.08)]">
            <img
              alt="Multi-Agent Reasoning"
              src="/assets/home/multiagent.webp"
              className="w-full h-auto block"
            />
          </div>
          <div className="flex-1 rounded-2xl border-2 border-blue-200 overflow-hidden bg-white shadow-[0_4px_20px_0_rgba(99,102,241,0.08)]">
            <img
              alt="Zero-Code Workflow"
              src="/assets/home/0code.webp"
              className="w-full h-auto block"
            />
          </div>
        </div>

        <p className="mt-10 text-center text-2xl font-bold tracking-wide text-blue-600">
          Interpretable &bull; Adaptive &bull; Efficient
        </p>
      </div>
    </div>
  );
}
